import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Button, CancelButton } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { OrderAdjustments } from 'types/embedded/orderAdjustments';
import { getId } from 'utils';

type Props = {
  open: boolean;
  onClose: VoidFunction;
  onConfirm: VoidFunction;
  record: OrderAdjustments | undefined;
};

export const OrderAdjustmentsReportConfirmSearchDialog: React.FC<Props> = ({
  open,
  record,
  onConfirm,
  onClose,
}) => {
  const translate = useTypedTranslate();

  return (
    <Dialog maxWidth="lg" onClose={onClose} open={open}>
      <CardHeader
        appendActions={<CloseIconButton key="close-button" onClose={onClose} />}
        sx={{ width: '640px' }}
        title={translate('app.orderAdjustmentsReport.searchDialogTitle')}
        titleSize="smallBold"
      />
      <CardContent>
        {translate('app.orderAdjustmentsReport.searchDialogText', {
          id: getId(record?.order?.['@id']),
        })}
      </CardContent>
      <CardActionsButtons
        rightActionsSlot={[
          <CancelButton
            key="cancel-button"
            label={translate('app.orderAdjustmentsReport.cancel')}
            onClick={onClose}
            variant="outlined"
          />,
          <Button
            key="confirm-button"
            label={translate('app.orderAdjustmentsReport.confirm')}
            onClick={onConfirm}
            variant="contained"
          />,
        ]}
      />
    </Dialog>
  );
};
